import { render, staticRenderFns } from "./room-light.vue?vue&type=template&id=437205e4&"
import script from "./room-light.vue?vue&type=script&lang=js&"
export * from "./room-light.vue?vue&type=script&lang=js&"
import style0 from "./room-light.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports